module.exports = __webpack_public_path__ + "static/media/29COICT1.f45681e5.jpg";